import { render, staticRenderFns } from "./ShowEvalua.vue?vue&type=template&id=06d71f58&"
import script from "./ShowEvalua.vue?vue&type=script&lang=js&"
export * from "./ShowEvalua.vue?vue&type=script&lang=js&"
import style0 from "./ShowEvalua.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports